import type { Token } from '@studio/models/livekit';
import { LiveKitTokenCreate } from '@tryiris-ai/mailroom-helper/livekit';
import { toIdFromHex, wrapApiCall } from '#~/api/index.js';
import { nats } from '#~/nats/index.js';

/**
 * Creates a LiveKit token.
 *
 * @param identity - Participant's identity.
 * @param room - LiveKit room.
 * @param token - Token.
 * @param roomJoin - Whether or not the room should be joined (default `true`).
 * @returns LiveKit token.
 * @throws An error if the token cannot be created.
 */
export const createToken = async (
  identity: string,
  room: string,
  token: string,
  deviceName: string,
  roomJoin: boolean = true
): Promise<{ token: Token; endpoint: string }> => {
  const result = await wrapApiCall(
    async () =>
      LiveKitTokenCreate.request(nats.cloudConnection(), {
        identity,
        room: toIdFromHex(room)!,
        roomJoin,
        token,
        deviceName
      }),
    'Unable to generate the LiveKit token.'
  );

  return { token: <Token>result.token, endpoint: result.endpoint };
};
